// Données de tarifs indicatifs (modifiable facilement)
// IMPORTANT: Ces tarifs sont purement indicatifs et doivent être adaptés.
// Chaque objet représente une "offre" ou un type de prestation.

export const pricingTiers = [
  {
    id: 'audit',
    title: 'Audit / Visite conseil sur chantier ',
    short: 'Analyse préalable',
  price: '150€/Demi-journée',
    unit: 'mission',
    idealFor: 'Avant de signer un devis ou lancer un chantier',
    features: [
      'Analyse structurée de vos devis (prix, cohérences)',
      'Identification postes manquants / gonflés',
      'Recommandations d’optimisation coût / qualité',
      'Restitution synthétique (oral ou écrit)' 
    ],
    note: 'Tarif ajusté selon taille du projet et nombre de devis.'
  },
  {
    id: 'faisabilite',
    title: 'Lecture de devis',
    short: 'Analyse de devis avant travaux',
    price: '40€/devis',
    unit: 'étude',
    // Lien de paiement Stripe (intégré en dur)
    stripeLink: 'https://buy.stripe.com/00w8wJdeCeFfa9e0zOeEo00',
    idealFor: 'Projets de rénovation, extension, réaménagement',
    features: [
      'Analyse technique du devis et prix proposés',
      'Conseil sur les prestations proposées',
      'Préconisations matériaux & options' 
    ],
    popular: true,
    note: 'Peut être déduit si mission de suivi ensuite.'
  },
  {
    id: 'suivi',
    title: 'Coaching de chantier',
    short: 'Accompagnement en cours d’exécution',
  price: '300€ / jour',
  unit: '', // suppression de l'affichage 'mois' comme demandé
    idealFor: 'Chantiers multi-lots ou clients éloignés',
    features: [
      'Visites planifiées & comptes rendus',
      'Contrôle qualité / conformité',
      'Aide aux arbitrages techniques',
      'Point budget & avenants' 
    ],
    note: 'Durée minimale : 2 mois (adaptable selon projet).'
  },
  {
    id: 'optimisation',
    title: 'Petit travaux / diagnostic',
    short: 'Plusieurs petits travaux différents',
    price: 'Sur devis',
    unit: '',
    features: [
      'Différent type de travaux',
      'Scénarios alternatifs',
      'Négociation fournisseurs (option)',
      'Synthèse économique chiffrée' 
    ],
    note: 'Peut inclure une part variable liée aux économies réalisées.'
  }
];
